import styled from 'styled-components';
import Back_Ellipse from "../../../assests/images/ls-page-image/back-ellipse.svg";
import Back_Rectangle from "../../../assests/images/ls-page-image/back-rectangle.svg";

export const GreatNonprofitsMain = styled.div`

`;
export const GreatNonprofitsInner = styled.div`
    max-width: 700px;
    width: 100%;
    background: #fff;
    box-shadow: 0px 0px 30px #C4E4E6;
    border-radius: 30px;
    padding: 20px 64px;
    margin: 0 auto;
    @media screen and (max-width:1280px) {
        padding: 20px 22px;
        border-radius: 20px;
    }
    @media screen and (max-width:1199px) {
        padding: 20px 10px;
        border-radius: 20px;
    }
    @media screen and (max-width:991px) {
        padding: 20px 45px;
     }
     @media screen and (max-width:768px) {
        padding: 20px 10px;
     }
     @media screen and (max-width:767px) {
           padding: 0px;
            background: transparent;
            box-shadow: none;
     }

    &.sing-up-mb-new{
        padding: 20px 52px 43px;
        @media screen and (max-width:1200px) {
            padding: 20px 28px 43px;
        }
        @media screen and (max-width:1080px) {
            padding: 20px 20px 43px;
        }
        @media screen and (max-width:1024px) {
            padding: 20px 12px 43px;
        }

        @media screen and (max-width:991px) {
            padding: 20px 30px 45px;
        }
        @media screen and (max-width:768px) {
            padding: 20px 10px 40px;
        }
        @media screen and (max-width:767px) {
            padding: 20px 10px 20px;
        }
    }
    &.sing-up-mb-new h1 {
        display: none;
    }
    
    h1.sing-up-mb-new1  {
        display: block;
    }


`;
export const GreatNonprofitsTitle = styled.h1`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 24px;
    line-height: 26px;
    text-align: center;
    margin-bottom: 22px;
    font-weight: bold;
    display:none;
    
    @media screen and (max-width:991px) {  
        font-size: 20px;
        line-height: 25px;
    }
    &.sing-up-mr-new{
        margin-bottom: 54px;
        display:block;
        @media screen and (max-width:767px) { 
            margin-bottom: 20px;
        }
    }
    
   
`;
export const GreatNonprofitsBox = styled.div`
    display: flex;
    align-items: flex-start;
    column-gap: 22px;
    @media screen and (max-width:1199px) { 
        justify-content:center;
    }
    @media screen and (max-width:767px) { 
        display: inline-block;
        width: 100%;
    }

`;
export const GreatNonprofitsBoxLeft = styled.div`
   img{
    @media screen and (max-width:991px) { 
       
    }
   }
`;
export const GreatNonprofitsImageLeft = styled.div`
    position: relative;
    z-index: 1;
     img{
        @media screen and (max-width:1199px) { 
            height: auto;
            max-width: 300px;
        }
        @media screen and (max-width:991px) { 
            max-width: 169px;
        }
     }
    &:after{
        content: '';
        width: 145px;
        height: 144px;
        position: absolute;
        top: auto;
        bottom: -47%;
        left: 32px;
        right: 0;
        background-image:url(${Back_Ellipse});
        background-size: 100% 100%; 
        background-repeat: no-repeat;
        z-index: -1;
        transform: translateY(-50%);
        @media screen and (max-width:767px) { 
            display:none;
          }
    }
    img{
        @media screen and (max-width:767px) { 
          display:none;
        }
    }
`;
export const GreatNonprofitsBoxRight = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    row-gap: 22px;
    margin-top: 102px;
    position: relative;
    z-index: 1;
    @media screen and (max-width:767px) { 
        margin-top: 20px;
        align-items: self-start;
    }
    &.sing-up-mrt-new{
        margin-top: 92px;
        @media screen and (max-width:767px) { 
            margin-top: 20px;
        } 
    }

    &:after{
        content: '';
        width: 149px;
        height: 217px;
        position: absolute;
        top: auto;
        bottom: -15%;
        left: auto;
        right: -59%;
        background-image:url(${Back_Rectangle});
        background-size: 100% 100%; 
        background-repeat: no-repeat;
        z-index: -1;
        transform: translate(-50%, -50%);
        @media screen and (max-width:1199px) {
              display:none;
         }
    }
`;
export const GreatNonprofitsImageRight = styled.div`
    position: relative;
    width:100%;
      img{
        @media screen and (max-width:767px) {
            display:none;
       }
       @media screen and (max-width:1199px) { 
        height: auto;
        max-width: 180px;
    }
       @media screen and (max-width:991px) {
         max-width:120px;
         height: auto;
       }

      }
`;

export const BackBlueBox = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    column-gap: 10px;
    @media screen and (max-width:767px) {
        position: static;
      
    }
    &.blue-box{
        background: #016B7B 0% 0% no-repeat padding-box;
        box-shadow: 0px 20px 20px #00000026;
        border-radius: 15px;
        padding: 11px 20px 11px 11px;
        display: none;

        &.login-box-one{
            top: -9%;
            right: -68%;
            left: auto;
            bottom: auto;
            display: flex;
            @media screen and (max-width:1199px) {
                right: -40%;
            }
            @media screen and (max-width:991px) {
                right: -13%;
             }
        }
        &.individual-box-one {
            width: 358px;
            top: 15%;
            right: -59%;
            left: auto;
            bottom: auto;
            transform: translate(50%, -50%);
            display: flex;
           

            @media screen and (max-width:1199px) {
                width: 300px;
                right: -57px;
            }
            @media screen and (max-width:991px) {
                right: 0;
            }
            @media screen and (max-width:767px) {
              transform: none;
              width: 100%;
            }
            &.blue-box-w{
                right: -39%;
                width: 370px;
                @media screen and (max-width:1080px) {
                   width: 100%;
                }
                @media screen and (max-width:991px) {
                    right: 0;       
                     width: 300px;
                }
                @media screen and (max-width:767px) {
                    width:100%;
                }
            }
        }
        &.individual-box-three{ 
            width: 340px;
            top: 0;
            right: auto;
            left: -60%;
            bottom: auto;
            transform: translate(-50%, -50%);
            display: flex;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: -10px 10px 20px #0000000F;
            @media screen and (max-width:991px) {
                left: -12%;
                width: 310px;
            }
            @media screen and (max-width:767px) {
                transform: none;
                margin-bottom: 20px;
                width: 100%;
              }
            .icon-back-white {
                background: #01606F 0% 0% no-repeat padding-box;
                box-shadow: -10px 20px 20px #0000000F;
              img{
                @media screen and (max-width:767px) {
                    display:block;
                }
              }
                + p {
                    color: #000000;
                    text-shadow: -10px 20px 20px #0000000F;
                }
            }
        }
    }
    

    &.multi-color-box{
        background: transparent linear-gradient(303deg, #F7931E 0%, #33A7AE 100%) 0% 0% no-repeat padding-box;
        box-shadow: 0px 10px 30px #00000014;
        border: 4px solid #F9FEFF;
        border-radius: 15px;
        display: none;
          @media screen and (max-width:767px) { 
             box-shadow:none;
             border:none;
         }
        &.login-box-two {
            top: 13%;
            left: auto;
            right: -67%;
            bottom: auto;
            transform: translate(-50%, -50%);
            padding: 15px 20px;
            display: flex;
            @media screen and (max-width:1199px) { 
                right: -32%;
            }
            @media screen and (max-width:991px) { 
                right: -19%;
                transform: none;
                top: -67%;
            }
        }
        &.individual-box-two {
            top: 50%;
            left: auto;
            right: 0;
            bottom: auto;
            transform: translate(50%, -50%);
            padding: 13px 19px;
            display: flex;
            text-align: center;
            @media screen and (max-width:1366px) {
                transform: translate(40%, -50%);
                right: 69px !important;
               width: 100%;
            }
            @media screen and (max-width:1199px) {
                right: 59% !important;
                width: 247px;
            }

            @media screen and (max-width:991px) {
                width: 261px;
                right: 86px !important;
            }
            @media screen and (max-width:767px) {
                transform: none;
                width: 100%;
              }
            &.box-text-left{
                text-align: left;
                padding: 12px;
                right: -12%;
                top: 63%;
                width: 220px;
               
                @media screen and (max-width:1280px) {
                    right: 30%;
                }
                @media screen and (max-width:1080px) {
                    right: 48%;
                }
                @media screen and (max-width:991px) {
                    right: 88%;
                }
            }
        }
    }

    &.white-box{
        background: #FFFFFF;
        box-shadow: -10px 20px 20px #0000000F;
        border-radius: 15px;
        padding: 11px;
        display: none;
       @media screen and (max-width:767px) { 
         box-shadow: none;
       }
        &.login-box-Three {
            top: auto;
            left: -33%;
            right: auto;
            bottom: -22%;
            transform: translate(-50%, -50%);
            display: flex;
            .icon-back-white {
                 background: #FFD495;
               } 
            p{
            color:#000;
            }
            @media screen and (max-width:991px) { 
                left: -150%;
                transform:none;
            }
        }

        &.individual-box-four{
            width: 249px;
            top: auto;
            left: -33%;
            right: auto;
            bottom: -36%;
            transform: translate(-50%, -50%);
            display: flex;
          

            @media screen and (max-width:991px) { 
                left:0;
                bottom: -67%;
            }
            @media screen and (max-width:767px) {
                transform: none;
                width:100%;
              }
                p{
                  color:#000;
                  }
             .icon-back-white {
                 background: #FFD495;
               }     
        } 
        &.individual-box-five{
            width: 363px;
            display: flex;
            top: 55%;
            left: -54%;
            right: auto;
            bottom: auto;
            transform: translate(-50%, -50%);
            align-items: stretch;
              .icon-back-white {
                 background: #FFD495;
               } 
            p{
            color:#000;
}
            @media screen and (max-width:991px) {
                left: -31%;
            }
            @media screen and (max-width:767px) {
                transform: none;
                width: 100%;
              }
        }
    }
    
`;
export const BackWhiteIcon = styled.div`
    padding: 15px;
    border-radius: 9px;
    @media screen and (max-width:1199px) { 
        padding: 5px;
        border-radius:8px;
    } 
    img{
        @media screen and (max-width:767px) {
            display:block;
        }
      }
    &.icon-back-white {
        background: #FFFFFF;
        img{
            @media screen and (max-width:767px) {
                display:block;
            }
          }
    }
    &.icon-back-yellow{
        background: #FFD495
       
    }
`;
export const BoxText = styled.p`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 25px;
    margin-bottom: 0;
    @media screen and (max-width:1199px) { 
        font-size: 16px;
        line-height: 20px;
        text-align: left;
    }
    &.login-text-box-three, &.login-text-box-four, &.login-text-box-five{
        color: #333333;
    }
`;
export const BoxNumber = styled.span`
    display: block;
    font-size: 21px;
    font-weight: 800;
    @media screen and (max-width:991px) { 
        font-size: 18px;
        line-height: 20px;
    }
`;

export const SingUPLeftBox = styled.div``; 